export enum ContractTypesEnum {
  DEVELOPER = 'developer',
  CONTRACTOR = 'contractor',
}
